import React from 'react'
import { Navigate } from 'react-router-dom';

const PayrollListWrapper = () => {
    return <Navigate to="/payroll/list/" />;

}

export default PayrollListWrapper